import { getResendLinkUrl, PROFILE_IMAGE } from "common/constants/apiUrls";
import { postData, updateData } from "networkManager/NetworkManager";

export const updateProfilePicture = async (requestPayload) => {
  const result = await updateData(PROFILE_IMAGE, requestPayload);
  return result;
};

export const setResendPasswordLink = async (queryParams) => {
  const url = getResendLinkUrl(queryParams);
  const result = await postData(url);
  return result;
};
export const changeLanguagePreference = async (language) => {
  const result = await updateData(
    `/vds/api/v1/user/language-preference?languagepreference=${language}`
  );
  return result;
};
